import React from "react";

const UserInfo = ({ userInfo, setUserInfo }) => {
  const handleChange = (field) => (e) => {
    setUserInfo((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const getFieldStyle = (hasError) => ({
    maxWidth: "85%",
    width: "85%",
    padding: "5px 10px",
    borderRadius: "6px",
    border: hasError ? "1px solid #F63030" : "1px solid #ccc",
    fontSize: "14px",
    marginLeft: "10px",
    marginRight: "20px",
    color: hasError ? "#F63030" : "#000",
  });

  return (
    <ul className=" quetions_list ifream_quetion_list  max-w-[1050px] w-full mx-auto flex flex-col items-center">
      {/* Age */}
      <li className={"w-100 rounded-[8px] !p-[0px] flex justify-between "}>
        <p className="text-[14px] font-[600] flex gap-[10px] text-[#3C4049]">
          Age :
        </p>
        <input
          type="number"
          min={1}
          max={120}
          value={userInfo.age}
          onChange={handleChange("age")}
          className="h-[40px]"
          placeholder="Enter your age"
          style={getFieldStyle(false)}
        />
      </li>

      {/* Sex */}
      <li className={"w-100  rounded-[8px] !p-[0px] flex justify-between "}>
        <p className="text-[14px] font-[600] flex gap-[10px] text-[#3C4049]">
          Sex :
        </p>
        <select
          value={userInfo.sex}
          onChange={handleChange("sex")}
          className="h-[40px]"
          style={getFieldStyle(false)}
        >
          <option value="">Select Sex</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          {/* <option value="other">Other</option> */}
        </select>
      </li>
      <li className={"w-100  rounded-[8px] !p-[0px] flex justify-between "}>
        <p className="text-[14px] font-[600] flex gap-[10px] text-[#3C4049]">
          Ethnicity :
        </p>
        <select
          value={userInfo.ethnicity}
          onChange={handleChange("ethnicity")}
          className="h-[40px]"
          style={getFieldStyle(false)}
        >
          <option value="">Select ethnicity</option>
          <option value="hispanic or latino">Hispanic or Latino</option>
          <option value="not hispanic or latino">Not Hispanic or Latino</option>
          <option value="wish not to disclose">Wish not to disclose</option>
          {/* <option value="other">Other</option> */}
        </select>
      </li>
      <li className={"w-100  rounded-[8px] !p-[0px] flex justify-between "}>
        <p className="text-[14px] font-[600] flex gap-[10px] text-[#3C4049]">
          Race :
        </p>
        <select
          value={userInfo.race}
          onChange={handleChange("race")}
          className="h-[40px]"
          style={getFieldStyle(false)}
        >
          <option value="">Select race</option>
          <option value="white">White</option>
          <option value="black or african american">
            Black or African American
          </option>
          <option value="asian">Asian</option>
          <option value="american indian or alaska native">
            American Indian or Alaska Native
          </option>
          <option value="native hawaiian or other pacific islander">
            Native Hawaiian or Other Pacific Islander
          </option>
          <option value="mixed">Mixed</option>
          <option value="wish to not disclose">Wish to not disclose</option>
          {/* <option value="other">Other</option> */}
        </select>
      </li>
    </ul>
  );
};

export default UserInfo;
